export default {
  'auth_rule': {
    'form_parentid': 'Parent',
    'form_select': 'Please select',
    'form_title': 'Title',
    'form_enter_title': 'enter title',
    'form_url': 'Url',
    'form_url_tooltip': 'default url not need add prefix',
    'form_enter_url': 'enter url',
    'form_url_tip': 'default prefix: admin-api/ and config can update it.',
    'form_method': 'Method',
    'form_slug': 'Slug',
    'form_enter_slug': 'enter slug',
    'form_description': 'Desc',
    'form_enter_description': 'enter desc',
    'form_listorder': 'Sort',
    'form_enter_listorder': 'enter sort',
    'form_listorder_tip': 'rule is top when sort is large',
    'form_need_auth': 'NeedAuth',
    'form_need_auth_enable': 'Enable',
    'form_need_auth_disable': 'Disable',
    'form_status': 'Status',
    'form_status_enable': 'Enable',
    'form_status_disable': 'Disable',
    'form_save': 'Save',
    'form_top_rule': 'top rule',
    'form_create_success': 'create success',
    'form_update_success': 'update success',
    
    'rules_parentid_required': 'parent required',
    'rules_title_required': 'title required',
    'rules_url_required': 'url required',
    'rules_slug_required': 'slug required',
    'rules_listorder_required': 'sort required',

    'search_title': 'Rules',
    'search_delete_selected': 'Delete',
    'search_searchword': 'enter keywords',
    'search_method': 'Method',
    'search_status': 'Status',
    'search_btn': 'Search',
    'search_method_get': 'GET',
    'search_method_head': 'HEAD',
    'search_method_post': 'POST',
    'search_method_put': 'PUT',
    'search_method_delete': 'DELETE',
    'search_method_patch': 'PATCH',
    'search_method_options': 'OPTIONS',
    'search_status_enable': 'Enable',
    'search_status_disable': 'Disable',
    'search_sort_asc': 'Asc',
    'search_sort_desc': 'Desc',
    'search_all_rule': 'All',
    'search_create_rule': 'Create',
    'search_rule_tree': 'Tree',
    
    'table_title': 'Title',
    'table_url': 'Url',
    'table_copy_slug': 'Copy {slug}',
    'table_listorder': 'Sort',
    'table_create_time': 'CreateTime',
    'table_status': 'Status',
    'table_actions': 'Actions',
    'table_detail': 'Detail',
    'table_update': 'Update',
    'table_delete': 'Delete',
    'table_listorder_success': 'update sort success',
    
    'dialog_create': 'Rule create',
    'dialog_update': 'Rule update',
    'dialog_detail': 'Rule detail',
    
    'detail_id': 'ID',
    'detail_parentid': 'Parent',
    'detail_title': 'Title',
    'detail_url': 'Url',
    'detail_method': 'Method',
    'detail_slug': 'Slug',
    'detail_description': 'Desc',
    'detail_listorder': 'Sort',
    'detail_need_auth': 'NeedAuth',
    'detail_status': 'Status',
    'detail_update_time': 'UpdateTime',
    'detail_update_ip': 'UpdateIp',
    'detail_create_time': 'CreateTime',
    'detail_create_ip': 'CreateIp',
    
    'enable_success': 'enable success',
    'disable_success': 'disable success',
    'confirm_delete': 'confirm delete the rule?',
    'confirm_delete_success': 'delete the rule success',
    'confirm_delete_selected': 'confirm delete the selected rule?',
    'select_delete_rules': 'pleace will delete rules',
  },
}
